var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.00107H7.00667M9.35702 9.35809C6.23283 12.4823 2.64489 13.9597 1.34315 12.6579C0.0413996 11.3562 1.51878 7.76824 4.64298 4.64405C7.76717 1.51985 11.3551 0.0424699 12.6569 1.34422C13.9586 2.64597 12.4812 6.2339 9.35702 9.35809ZM9.357 4.64393C12.4812 7.76812 13.9586 11.3561 12.6568 12.6578C11.3551 13.9596 7.76715 12.4822 4.64295 9.35797C1.51876 6.23378 0.0413728 2.64584 1.34312 1.3441C2.64487 0.0423493 6.2328 1.51973 9.357 4.64393ZM7.33333 7.00107C7.33333 7.18517 7.1841 7.3344 7 7.3344C6.81591 7.3344 6.66667 7.18517 6.66667 7.00107C6.66667 6.81698 6.81591 6.66774 7 6.66774C7.1841 6.66774 7.33333 6.81698 7.33333 7.00107Z",
    stroke: "#3F4FF8",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthPlanIcon);
export default __webpack_public_path__ + "static/media/growth-plan-icon.9c44e25b89819036e43944c78f5be5ac.svg";
export { ForwardRef as ReactComponent };